import moment from 'moment';
import DateUtils from '../../utils/date_utils';

export default class SortingHandler {
	static dateFormat = null;
	static dateTimeFormat = null;

	static sort(dataRows, { field, direction, format }) {
		let comparator = this.getComparatorFunction(format);
		let directionMultiplier = this.getDirectionMultiplier(direction);

		this.setDateFormats();
		return dataRows.sort(comparator.bind(this, field, directionMultiplier));
	}

	static getComparatorFunction(format) {
		switch(format) {
			case 'currency':
			case 'number':
			case 'percentage':
			return this.numberComparator;
			case 'date':
			return this.dateComparator;
			case 'datetime':
			return this.dateTimeComparator;
			case 'text':
			case 'boolean':
			default:
			return this.textComparator;
		}
	}

	static getDirectionMultiplier(direction) {
		switch(direction) {
			case 'desc':
			return -1;
			case 'asc':
			default:
			return 1;
		}
	}

	static setDateFormats() {
		this.dateFormat = Realize.i18n.t('date.formats.date');
		this.dateTimeFormat = Realize.i18n.t('date.formats.default');
	}

	static getDataRowField(dataRow, fieldName) {
		const displayFieldName = `${fieldName}Display`;
		const dataRowField = dataRow[displayFieldName] || dataRow[fieldName];
		if(Array.isArray(dataRowField)) {
			return dataRowField[0];
		}

		return dataRowField;
	}

	static numberComparator(field, directionMultiplier, dataRow1, dataRow2) {
		let number1 = parseFloat(this.getDataRowField(dataRow1, field));
		let number2 = parseFloat(this.getDataRowField(dataRow2, field));

		return (number1 - number2) * directionMultiplier;
	}

	static textComparator(field, directionMultiplier, dataRow1, dataRow2) {
		let text1 = this.getDataRowField(dataRow1, field);
		let text2 = this.getDataRowField(dataRow2, field);

		return text1.localeCompare(text2) * directionMultiplier;
	}

	static dateComparator(field, directionMultiplier, dataRow1, dataRow2) {
		return this.dateTypeComparator(field, directionMultiplier, dataRow1, dataRow2, this.dateFormat);
	}

	static dateTimeComparator(field, directionMultiplier, dataRow1, dataRow2) {
		return this.dateTypeComparator(field, directionMultiplier, dataRow1, dataRow2, this.dateTimeFormat);
	}

	static dateTypeComparator(field, directionMultiplier, dataRow1, dataRow2, dateTypeFormat) {
		let date1 = DateUtils.convertDateStringToMoment(this.getDataRowField(dataRow1, field));
		let date2 = DateUtils.convertDateStringToMoment(this.getDataRowField(dataRow2, field));

		return date1.diff(date2) * directionMultiplier;
	}
}
